<template>
  <!--
    作者：kmdshop
    时间：2020-06-04
    描述：插件中心-积分商城-基本设置
  -->
  <div class="user">
    <div class="common-form d-s-c"><span>设置项</span></div>
    <div class="p20">
      <el-form ref="form" size="small" label-width="160px">
        <el-form-item label="是否开启活动" prop="is_open"><el-switch v-model="form.is_open"></el-switch></el-form-item>
        <el-form-item label="是否开启优惠券" prop="is_coupon"><el-switch v-model="form.is_coupon"></el-switch></el-form-item>
        <el-form-item label="是否开启分销" prop="is_agent"><el-switch v-model="form.is_agent"></el-switch></el-form-item>
        <el-form-item label="是否开启推送" prop="points_push_is_open"><el-switch v-model="form.points_push_is_open"></el-switch></el-form-item>
        <el-form-item label="是否推送数量自定义" prop="points_push_count_is_diy"><el-switch v-model="form.points_push_count_is_diy"></el-switch></el-form-item>
        <el-form-item label="是否直接跳转" prop="points_push_is_direct_jump"><el-switch v-model="form.points_push_is_direct_jump"></el-switch></el-form-item>
        <el-form-item label="兑换按钮文字"  prop="points_push_btn_text">
          <el-input v-model="form.points_push_btn_text" placeholder="不填默认下一步" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="推送协议"  prop="points_rules_text">
          <el-input v-model="form.points_rules_text" placeholder="推送协议"  type="textarea" :rows="3" class="max-w460"></el-input>
        </el-form-item>
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import PointSettingApi from '@/api/pointsstting.js';
export default {
  data() {
    return {
      form: {
        /*是否开启活动*/
        is_open: false,
        /*是否开启优惠券*/
        is_coupon: false,
         /*是否开启分销*/
        is_agent: false,
        /** 是否开启推送*/
        points_push_is_open:false,
        /** 推送成功是否直接跳转*/
        points_push_is_direct_jump:false,
        /** 推送协议规则 */
        points_rules_text:"",
        /** 推送按钮文字*/
        points_push_btn_text:"",

        /** 积分推送积分数量是否可以自定义 */
        points_push_count_is_diy:false
      },
      loading: false
    };
  },
  created() {
    /*获取数据*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      PointSettingApi.getConfig({}, true)
        .then(data => {
          self.form = data.data.vars.values;
        })
        .catch(error => {});
    },

    /*提交保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      PointSettingApi.saveConfig(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，保存成功',
            type: 'success'
          });
          self.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/points/setting/Base.vue